<template>
  <div>
    <v-menu class="language-list" min-width="120"  offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            tag="div"
            small
            class="black--text text--lighten-4 elevation-1 px-1"
            v-bind="attrs"
            v-on="on"
            :dark="dark"
            :light="light"
        >
          <div class="d-flex align-center">
            <div
                class="language-selector--flag d-inline-flex justify-center align-center px-0 py-1 mr-1 transparent text-capitalize"
                :class="{
                  'white--text': dark,
                  'ml-1': !flag
                }"
            >
              <img v-show="flag" class="mr-1" :src="getFlag(getCurrent('code'))" alt="Flag" />
              <v-icon size="16" :class="!flag && 'mr-1'" :color="iconColor">mdi-translate</v-icon>
              <div class="mr-1">{{ getCurrent("language") }}</div>
            </div>
          </div>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group v-model="current" mandatory>
          <v-list-item
              :value="lang"
              class="px-2"
              dense
              :key="lang"
              v-for="(langData, lang) in languagesDetails"
              @click="setCurrent(lang)"
          >
            <v-list-item-title>
              <v-row dense>
                <v-col cols="3" class="d-flex align-center">
                  <img width="27" height="20" :src="getFlag(lang)" class="mr-1" />
                </v-col>
                <v-col class="d-flex justify-center align-center">
                  {{ langData.language }}
                </v-col>
              </v-row>
            </v-list-item-title>
            <!--          <v-list-item-action v-show="isActive(lang)">-->
            <!--            <v-icon size="15">mdi-check</v-icon>-->
            <!--          </v-list-item-action>-->
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LanguageSelector",

  props: {
    value: Object,
    dark: Boolean,
    light: Boolean,
    flag: Boolean,
    iconColor: String,
  },

  data() {
    return {
      currentDetail: {},
      current: null
    };
  },

  computed: {
    ...mapState({
      languagesDetails: state => state.Language.languagesDetails,
      apiLanguage: state => state.Language.apiLanguage
    })
  },

  methods: {
    setCurrent(lang) {
      this.current = lang;
      this.currentDetail = this.languagesDetails[this.current];
      this.emitValue();
    },

    getFlag(lang) {
      if (this.current) {
        return require("@/assets/country-flags/" +
          this.getLanguageCode(lang) +
          ".png");
      } else {
        return "";
      }
    },

    getLanguageCode(lang) {
      return lang.substring(3, 5).toLowerCase();
    },

    getCurrent(name) {
      if (this.current) {
        let currentDetail = {
          ...this.currentDetail,
          ...this.setCode(this.current)
        };
        return currentDetail[name];
      } else {
        return "";
      }
    },

    /**
     * Code özelliği için Computed Property Name
     */
    setCode(code) {
      return {
        ["code"]: code
      };
    },

    parseReference(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    isActive(langCode) {
      return this.current === langCode;
    },

    emitValue() {
      const langData = { code: this.current, ...this.currentDetail };
      this.$emit('change', langData);
      this.$emit('input', langData);
    }
  },

  mounted() {
    this.emitValue();
  },

  created() {
    this.current = this.apiLanguage;

    // Geçerli dil üzerinden dil detayını al
    this.currentDetail = this.languagesDetails[this.current];

  }
};
</script>

<style scoped>
.language-selector--flag img {
  width: 30px;
  border-radius: 3px;
}
</style>